import { Base } from '../base-component';
import './image-with-text.component.scss';

export class ImageWithText extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/image-with-text/image-with-text.component.ts